var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',[_c('div',{staticClass:"rightMenu"},[_c('div',{staticClass:"item message-box",on:{"click":function($event){return _vm.clkIM()}}},[_c('div',{class:['icon1',{
            'close-calss':!_vm.isShow
          }]},[_c('img',{attrs:{"src":"/static/img/kefu.png","width":"64px","height":"64px"}}),_vm._v(" "),(!_vm.isShow)?_c('div',{staticClass:"bg-img"},[_vm._v("Close")]):_vm._e()])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fed09e26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/defaults.vue
// module id = null
// module chunks = 